const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.style.setProperty('--animation-order', index);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -70px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
// function initializeScrollZoomAnimationTrigger() {
//   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
//
//   const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
//
//   if (animationTriggerElements.length === 0) return;
//
//   const scaleAmount = 0.2 / 100;
//
//   animationTriggerElements.forEach((element) => {
//     let elementIsVisible = false;
//     const observer = new IntersectionObserver((elements) => {
//       elements.forEach((entry) => {
//         elementIsVisible = entry.isIntersecting;
//       });
//     });
//     observer.observe(element);
//
//     element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
//
//     window.addEventListener(
//       'scroll',
//       throttle(() => {
//         if (!elementIsVisible) return;
//
//         element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
//       }),
//       { passive: true }
//     );
//   });
// }

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  // initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

// ZENHAX section-level reveal motion.
 // Reveal sections once, after layout is stable. The previous implementation could
 // toggle hidden content while a mobile scroll was still settling.
const zenhaxObservedSections = new WeakSet();
const zenhaxRevealObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const section = entry.target;
        observer.unobserve(section);
        requestAnimationFrame(() => section.classList.add('is-zenhax-visible'));
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' })
  : null;

function initZenhaxReveal(root = document) {
  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !zenhaxRevealObserver
  ) return;

  const sections = [];
  if (root instanceof Element && root.classList.contains('shopify-section')) sections.push(root);
  if (root.querySelectorAll) sections.push(...root.querySelectorAll('main .shopify-section'));

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  [...new Set(sections)].forEach((section, index) => {
    if (zenhaxObservedSections.has(section)) return;

    const initialTop = section.getBoundingClientRect().top;
    if (initialTop <= viewportHeight * 0.75) return;

    section.setAttribute('data-zenhax-reveal', '');
    section.classList.add(index % 2 ? 'zenhax-reveal--from-top' : 'zenhax-reveal--from-bottom');

    // Keep content-visibility off on small screens: intrinsic-height guesses can
    // move the scroll position as sections become visible and cause CLS/flicker.
    if (
      initialTop > viewportHeight * 1.2 &&
      window.matchMedia('(min-width: 750px)').matches
    ) {
      section.classList.add('zenhax-deferred-section');
    }

    zenhaxObservedSections.add(section);
    zenhaxRevealObserver.observe(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initZenhaxReveal(), { once: true });
} else {
  initZenhaxReveal();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initZenhaxReveal(event.target));
  document.addEventListener('shopify:section:reorder', () => initZenhaxReveal(document));
}